module.exports = __webpack_public_path__ + "img/06.02f667a9.jpg";